import { RepositoryService } from './repositories/repository.service';
import { FormPendentGuard } from './guards/deactivate/form-pendent.guard';
import { JwtInterceptor } from './auth/jwt.interceptor';
import { AuthenticationService } from './auth/authentication.service';
import { CommonModule } from '@angular/common';
import { NgModule, SkipSelf, Optional, ModuleWithProviders } from '@angular/core';
import { IsLoggedGuard } from './guards/is-logged.guard';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UsersService } from './repositories/users.service';
import { ExternalAccesoGuard } from './guards/deactivate/external-acceso.guard';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [IsLoggedGuard, FormPendentGuard, AuthenticationService, UsersService, RepositoryService, ExternalAccesoGuard]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() core: CoreModule) {
    if (core) {
      throw new Error('CoreModule ya está cargado. Impórtalo solo en el AppModule');
    }
  }
  static forRoot() {
    return {
      ngModule: CoreModule,
      providers: [
        UsersService,
        AuthenticationService,
        RepositoryService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
      ]
    };
  }
}
